import { all, fork } from 'redux-saga/effects'
import { billingSaga } from '@/features/billing/store/sagas'
import { userSaga } from '@/features/user/store/sagas'

export default function* rootSaga() {
  yield all([fork(billingSaga), fork(userSaga)])
}
